import * as React from 'react';

import { HonestWork } from '@cian/honestwork-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { Avatar } from '../../common/components/avatar';
import { LinkWrapper } from '../../common/components/link_wrapper';
import { Tag } from '../../common/components/tag';
const logo = require('./logo.png') as string;
import * as styles from './index.css';

export const CianAgencyBrand = () => (
  <>
    <div className={styles['container']}>
      <div className={styles['content']}>
        <div className={styles['honest-container']}>
          <HonestWork className={styles['tag']} />
          <Tag {...mergeStyles([styles['tag'], styles['tag-pro']])} title="Профессиональный пользователь">
            Pro
          </Tag>
        </div>
        <div className={styles['link-wrapper']}>
          <h2 className={styles['title']}>Эксклюзивно от Циан</h2>
        </div>
        <div className={styles['prop']}>Циан принимает звонок</div>
      </div>
      <LinkWrapper target="_blank" notRemoveWrapper href={undefined} className={styles['avatar-wrapper']}>
        <Avatar className={styles['avatar']} url={logo} />
      </LinkWrapper>
    </div>
  </>
);
